import React, { useState, useRef, useEffect } from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Image,
  TextInput,
  SafeAreaView,
  FlatList,
  Modal,
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  Dimensions,
  Alert
} from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { toast } from 'sonner-native';
import { fetchClientesDesdeAPI, Client } from '../persistencia/clienteService';
import { fetchCategoriasDesdeAPI, Categoria } from '../persistencia/categoriaService';
import { fetchProductosDesdeAPI, Product } from '../persistencia/productoService';

// Paso 2: Integramos un campo de búsqueda + botón al componente ClientsTab
//import React, { useState } from 'react';
import { ActivityIndicator } from 'react-native';


// TYPES
interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  image: string;
  category: string;
  discount?: number;
}

interface Client {
  id: string;
  name: string;
  email: string;
  totalPurchases: number;
}

interface Category {
  id: string;
  name: string;
  description: string;
  productCount: number;
  image: string;
}

// MOCK DATA
/*
const PRODUCTS: Product[] = [
  {
    id: "1",
    name: "Laptop HP ProBook",
    description: "Laptop profesional con procesador i5, 8GB RAM, 256GB SSD",
    price: 899.99,
    image: "https://api.a0.dev/assets/image?text=laptop%20professional%20business&aspect=1:1",
    category: "Computadoras",
    discount: 0
  },
  {
    id: "2",
    name: "Monitor Samsung 24\"",
    description: "Monitor LED Full HD 1080p con panel IPS",
    price: 199.99,
    image: "https://api.a0.dev/assets/image?text=monitor%20samsung%20display&aspect=1:1",
    category: "Periféricos",
    discount: 10
  },
  {
    id: "3",
    name: "Impresora Brother",
    description: "Impresora láser monocromática, 32 ppm",
    price: 149.99,
    image: "https://api.a0.dev/assets/image?text=laser%20printer%20office&aspect=1:1",
    category: "Impresoras",
    discount: 0
  }
]; */
const clientes: Client[] = [ /* datos fijos */ ]
const CATEGORIES: Categoria[] = [ /* datos fijos */ ]
const PRODUCTS: Product[] = []

const SERVICES = [
  {
    id: "s1",
    name: "Soporte Técnico (1 hora)",
    price: 80,
    discount: 0,
    icon: "laptop"
  },
  {
    id: "s2",
    name: "Mantenimiento de Sistema",
    price: 150,
    discount: 10,
    icon: "cog"
  },
  {
    id: "s3",
    name: "Instalación de Software",
    price: 60,
    discount: 0,
    icon: "application"
  }
];

const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  EUR: '€',
  MXN: '$'
};

// PRODUCT CARD COMPONENT
const ProductCard: React.FC<{
  product: Product;
  onAddToCart: (product: Product) => void;
}> = ({ product, onAddToCart }) => {
  return (
    <View style={styles.productCard}>
      <Image source={{ uri: product.image }} style={styles.productImage} />
      <View style={styles.productInfo}>
        <Text style={styles.productName}>{product.name}</Text>
        <Text style={styles.productDescription}>{product.description}</Text>
        <View style={styles.productPriceRow}>
          <Text style={styles.productPrice}>
            {product.discount ? (
              <>
                <Text style={styles.discountedPrice}>
                  ${product.price.toFixed(2)}
                </Text>
                {' $' + (product.price * (1 - product.discount / 100)).toFixed(2)}
              </>
            ) : (
              '$' + product.price.toFixed(2)
            )}
          </Text>
          {product.discount > 0 && (
            <View style={styles.discountBadge}>
              <Text style={styles.discountText}>{product.discount}% OFF</Text>
            </View>
          )}
        </View>
        <TouchableOpacity
          style={styles.addButton}
          onPress={() => onAddToCart(product)}
        >
          <MaterialCommunityIcons name="cart-plus" size={16} color="#fff" />
          <Text style={styles.addButtonText}>Agregar</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

// MAIN COMPONENT
const HomeScreen: React.FC = () => {
  // Main states
  
  const [tab, setTab] = useState('home');
  const [cart, setCart] = useState<Product[]>([]);
  const [selectedClient, setSelectedClient] = useState<Client | null>(null);
  const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);
  const [clientes, setClientesGlobal] = useState<Client[]>([]);



  const [CATEGORIES, setCATEGORIES] = useState<Categoria[]>([]);
  const [PRODUCTS, setPRODUCTS] = useState<Product[]>([]);
  
  // Agregar esta línea
  const [isLoading, setIsLoading] = useState(false);



  useEffect(() => {
    const cargarCategorias = async () => {
      const data = await fetchCategoriasDesdeAPI();
      setCATEGORIES(data);
    };
    cargarCategorias();
  }, []);
  
 /* useEffect(() => {
  const cargarProductos = async () => {
    const data = await fetchProductosDesdeAPI();
    setPRODUCTS(data);
  };
  cargarProductos();
}, []);*/

//solo destacados destacados
useEffect(() => {
  const cargarDestacados = async () => {
    setIsLoading(true);
    const data = await fetchProductosDesdeAPI("", "S");
 

    setPRODUCTS(data);
    setIsLoading(false);
  };
  cargarDestacados();
}, []);

useEffect(() => {
  const cargarProductosPorCategoria = async () => {
    if (selectedCategory) {
      setIsLoading(true);
      const productosFiltrados = await fetchProductosDesdeAPI(selectedCategory.id);
      setPRODUCTS(productosFiltrados);
      setIsLoading(false);
    }
  };
  cargarProductosPorCategoria();
}, [selectedCategory]);






  // Form and modal states
  const [showCart, setShowCart] = useState(false);
  const [showCheckout, setShowCheckout] = useState(false);
  const [checkoutStep, setCheckoutStep] = useState(1);
  const [billingOptions, setBillingOptions] = useState({
    currency: 'USD',
    paymentMethod: 'cash'
  });
  
 

  // Form errors state
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});
  
  // Service form state
  const [serviceForm, setServiceForm] = useState({
    description: '',
    price: '',
    discount: '0'
  });
  const [calculatedPrice, setCalculatedPrice] = useState(0);
  
  // NEW: Checkout form data state that will be used for confirmation
  const [checkoutFormData, setCheckoutFormData] = useState({
    contactPerson: '',
    email: '',
    phone: '',
    address: ''
  });
  
  // Form refs for uncontrolled inputs
  const formRefs = useRef({
    contactPerson: React.createRef<TextInput>(),
    email: React.createRef<TextInput>(),
    phone: React.createRef<TextInput>(),
    address: React.createRef<TextInput>()
  });
  
  // CART FUNCTIONS
  const addToCart = (product: Product) => {
    const finalPrice = product.discount 
      ? product.price * (1 - (product.discount / 100)) 
      : product.price;
      
    const productWithFinalPrice = {
      ...product,
      price: finalPrice
    };
    
    setCart(prev => [...prev, productWithFinalPrice]);
    toast.success(`${product.name} agregado al carrito`);
  };
  
  const removeFromCart = (productId: string) => {
    setCart(prev => prev.filter(item => item.id !== productId));
  };
  
  const getCartTotal = () => {
    return cart.reduce((total, item) => total + item.price, 0);
  };
  
  // SERVICE FUNCTIONS
  const calculateServicePrice = () => {
    if (!serviceForm.price) return;
    
    const price = parseFloat(serviceForm.price);
    const discount = parseFloat(serviceForm.discount) || 0;
    const finalPrice = price * (1 - (discount / 100));
    
    setCalculatedPrice(finalPrice);
  };
  
  const addServiceToCart = () => {
    if (!serviceForm.description || !serviceForm.price) {
      toast.error("Por favor complete la descripción y el precio del servicio.");
      return;
    }
    
    const newService: Product = {
      id: `service-${Date.now()}`,
      name: serviceForm.description,
      description: serviceForm.description,
      price: calculatedPrice > 0 ? calculatedPrice : parseFloat(serviceForm.price),
      image: "https://api.a0.dev/assets/image?text=technical%20service%20support&aspect=1:1",
      category: "Servicios",
      discount: parseFloat(serviceForm.discount) || 0
    };
    
    setCart(prev => [...prev, newService]);
    toast.success(`Servicio agregado al carrito`);
    
    // Reset form
    setServiceForm({
      description: '',
      price: '',
      discount: '0'
    });
    setCalculatedPrice(0);
  };
  
  const addPredefinedService = (service: any) => {
    const discountedPrice = service.price * (1 - (service.discount / 100));
    
    setServiceForm({
      description: service.name,
      price: service.price.toString(),
      discount: service.discount.toString()
    });
    
    setCalculatedPrice(discountedPrice);
  };
  
  // CHECKOUT FUNCTIONS
  const startCheckout = () => {
    if (cart.length === 0) {
      toast.error("Su carrito está vacío.");
      return;
    }
    
    setShowCart(false);
    setShowCheckout(true);
    setCheckoutStep(1);
  };  // Captura de datos del formulario cuando se avanza al siguiente paso
  const captureFormData = () => {
    // Tomar los valores directamente de los refs
    const newData = {
      contactPerson: formRefs.current.contactPerson.current?.value || "",
      email: formRefs.current.email.current?.value || "",
      phone: formRefs.current.phone.current?.value || "",
      address: formRefs.current.address.current?.value || ""
    };
    
    // Guardar en el estado para mostrar en confirmación
    setCheckoutFormData(newData);
    return true;
  };
  
  const validateBillingForm = () => {
    // Get values directly from refs for validation
    const values = {
      contactPerson: formRefs.current.contactPerson.current?.value || '',
      email: formRefs.current.email.current?.value || '',
      phone: formRefs.current.phone.current?.value || '',
      address: formRefs.current.address.current?.value || ''
    };
    
    const errors: Record<string, string> = {};
    
    if (!values.contactPerson.trim()) {
      errors.contactPerson = "Nombre completo es requerido";
    }
    
    if (!values.email.trim()) {
      errors.email = "Email es requerido";
    } else if (!/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = "Email inválido";
    }
    
    if (!values.phone.trim()) {
      errors.phone = "Teléfono es requerido";
    }
    
    if (!values.address.trim()) {
      errors.address = "Dirección es requerida";
    }
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };  const goToNextStep = () => {
    if (checkoutStep === 1) {
      if (validateBillingForm()) {
        // Capturar datos del formulario antes de avanzar
        captureFormData();
        setCheckoutStep(2);
      }
    } else if (checkoutStep === 2) {
      setCheckoutStep(3);
    }
  };
  
  const goToPreviousStep = () => {
    if (checkoutStep > 1) {
      setCheckoutStep(checkoutStep - 1);
    } else {
      setShowCheckout(false);
    }
  };
  
  const cancelCheckout = () => {
    setShowCheckout(false);
    setCheckoutStep(1);
  };
  
  const completeOrder = () => {
    toast.success("¡Pedido completado con éxito!");
    setCart([]);
    setShowCheckout(false);
    setCheckoutStep(1);
  };  // Fill client data when selected
  const selectClient = (client: Client) => {
    setSelectedClient(client);
    
    // Update our checkout form data directly
    setCheckoutFormData(prev => ({
      ...prev,
      contactPerson: client.name,
      email: client.email
    }));
    toast.success(`Cliente ${client.name} seleccionado`);

    // Redirige automáticamente al tab "home"
    setTab('home');
  };
  
  // COMPONENT: CartModal
  const CartModal = () => (
    <Modal
      visible={showCart}
      transparent={true}
      animationType="fade"
      onRequestClose={() => setShowCart(false)}
    >
      <View style={styles.modalOverlay}>
        <View style={styles.modalContent}>
          <View style={styles.modalHeader}>
            <Text style={styles.modalTitle}>Carrito de Compras</Text>
            <TouchableOpacity onPress={() => setShowCart(false)}>
              <MaterialCommunityIcons name="close" size={24} color="#666" />
            </TouchableOpacity>
          </View>
          
          {cart.length === 0 ? (
            <Text style={styles.emptyMessage}>Su carrito está vacío</Text>
          ) : (
            <>
              <FlatList
                data={cart}
                keyExtractor={(item) => item.id}
                style={styles.cartList}
                renderItem={({ item }) => (
                  <View style={styles.cartItem}>
                    <Image source={{ uri: item.image }} style={styles.cartItemImage} />
                    <View style={styles.cartItemInfo}>
                      <Text style={styles.cartItemName}>{item.name}</Text>
                      <Text style={styles.cartItemPrice}>
                        {CURRENCY_SYMBOLS[billingOptions.currency as keyof typeof CURRENCY_SYMBOLS]}{item.price.toFixed(2)}
                      </Text>
                    </View>
                    <TouchableOpacity onPress={() => removeFromCart(item.id)}>
                      <MaterialCommunityIcons name="trash-can" size={24} color="#FF5252" />
                    </TouchableOpacity>
                  </View>
                )}
              />
              
              <View style={styles.cartTotal}>
                <Text style={styles.cartTotalLabel}>Total:</Text>
                <Text style={styles.cartTotalAmount}>
                  {CURRENCY_SYMBOLS[billingOptions.currency as keyof typeof CURRENCY_SYMBOLS]}{getCartTotal().toFixed(2)}
                </Text>
              </View>
              
              <TouchableOpacity 
                style={styles.primaryButton}
                onPress={startCheckout}
              >
                <Text style={styles.primaryButtonText}>Proceder al Pago</Text>
              </TouchableOpacity>
            </>
          )}
        </View>
      </View>
    </Modal>
  );
  
  // UNCONTROLLED FORM FIELD COMPONENT  // Componente no controlado para campos de formulario
  const FormField: React.FC<{
    label: string;
    field: keyof typeof formRefs.current;
    placeholder: string;
    keyboardType?: "default" | "email-address" | "numeric" | "phone-pad";
    nextField?: keyof typeof formRefs.current;
    defaultValue?: string;
  }> = ({ label, field, placeholder, keyboardType = "default", nextField, defaultValue }) => {
    const focusNextField = () => {
      if (nextField && formRefs.current[nextField].current) {
        formRefs.current[nextField].current?.focus();
      }
    };
    
    return (
      <View style={styles.formField}>
        <Text style={styles.formLabel}>
          {label} <Text style={styles.requiredText}>*</Text>
        </Text>
        <TextInput
          ref={formRefs.current[field]}
          style={[styles.formInput, formErrors[field] ? styles.inputError : {}]}
          placeholder={placeholder}
          defaultValue={defaultValue}
          keyboardType={keyboardType}
          returnKeyType={nextField ? "next" : "done"}
          onSubmitEditing={focusNextField}
        />
        {formErrors[field] && (
          <Text style={styles.errorText}>{formErrors[field]}</Text>
        )}
      </View>
    );
  };
  
  // CHECKOUT SCREEN
  const CheckoutScreen = () => {
    if (!showCheckout) return null;
    
    return (
      <View style={styles.fullscreenOverlay}>
        <KeyboardAvoidingView 
          behavior={Platform.OS === "ios" ? "padding" : "height"}
          style={styles.fullscreenContainer}
        >
          <View style={styles.checkoutHeader}>
            <TouchableOpacity onPress={goToPreviousStep}>
              <MaterialCommunityIcons name="arrow-left" size={24} color="#333" />
            </TouchableOpacity>
            <Text style={styles.checkoutTitle}>Checkout</Text>
            <TouchableOpacity onPress={cancelCheckout}>
              <Text style={styles.cancelText}>Cancelar</Text>
            </TouchableOpacity>
          </View>
          
          <View style={styles.progressIndicator}>
            <View style={styles.progressBar}>
              <View 
                style={[
                  styles.progressFill, 
                  { width: checkoutStep === 1 ? '0%' : checkoutStep === 2 ? '50%' : '100%' }
                ]} 
              />
            </View>
            {[1, 2, 3].map(step => (
              <View key={step} style={styles.stepItem}>
                <View style={[styles.stepCircle, checkoutStep >= step && styles.activeStep]}>
                  <Text style={[styles.stepNumber, checkoutStep >= step && styles.activeStepNumber]}>
                    {step}
                  </Text>
                </View>
                <Text style={[styles.stepLabel, checkoutStep >= step && styles.activeStepLabel]}>
                  {step === 1 ? "Información" : step === 2 ? "Pago" : "Confirmación"}
                </Text>
              </View>
            ))}
          </View>
          
          <ScrollView style={styles.checkoutContent}>
            {checkoutStep === 1 && (
              <View>
                <Text style={styles.sectionTitle}>Información de Facturación</Text>
                
                <View style={styles.currencySelector}>
                  <Text style={styles.formLabel}>Moneda</Text>
                  <View style={styles.optionRow}>
                    {['USD', 'EUR', 'MXN'].map(currency => (
                      <TouchableOpacity 
                        key={currency}
                        style={[
                          styles.currencyOption, 
                          billingOptions.currency === currency && styles.selectedOption
                        ]}
                        onPress={() => setBillingOptions({...billingOptions, currency})}
                      >
                        <Text style={[
                          styles.optionText, 
                          billingOptions.currency === currency && styles.selectedOptionText
                        ]}>
                          {currency} ({CURRENCY_SYMBOLS[currency as keyof typeof CURRENCY_SYMBOLS]})
                        </Text>
                      </TouchableOpacity>
                    ))}
                  </View>
                </View>
                
                <FormField 
                  label="Nombre Completo" 
                  field="contactPerson" 
                  placeholder="Nombre y apellido"
                  defaultValue={checkoutFormData.contactPerson}
                  nextField="email"
                />
                
                <FormField 
                  label="Email" 
                  field="email" 
                  placeholder="correo@ejemplo.com"
                  defaultValue={checkoutFormData.email}
                  keyboardType="email-address"
                  nextField="phone"
                />
                
                <FormField 
                  label="Teléfono" 
                  field="phone" 
                  placeholder="(123) 456-7890"
                  defaultValue={checkoutFormData.phone}
                  keyboardType="phone-pad"
                  nextField="address"
                />
                
                <FormField 
                  label="Dirección" 
                  field="address" 
                  placeholder="Calle, número, ciudad, país"
                  defaultValue={checkoutFormData.address}
                />
              </View>
            )}
            
            {checkoutStep === 2 && (
              <View>
                <Text style={styles.sectionTitle}>Método de Pago</Text>
                
                <View style={styles.paymentMethods}>
                  {[
                    { id: 'cash', title: 'Efectivo', icon: 'cash', color: '#4CAF50', description: 'Pago en efectivo al momento de la entrega' },
                    { id: 'transfer', title: 'Transferencia Bancaria', icon: 'bank-transfer', color: '#2196F3', description: 'Transferencia a nuestra cuenta bancaria' },
                    { id: 'card', title: 'Tarjeta', icon: 'credit-card', color: '#FF9800', description: 'Pago seguro con tarjeta' }
                  ].map(payment => (
                    <TouchableOpacity 
                      key={payment.id}
                      style={[
                        styles.paymentMethod,
                        billingOptions.paymentMethod === payment.id && styles.selectedPayment
                      ]}
                      onPress={() => setBillingOptions({...billingOptions, paymentMethod: payment.id})}
                    >
                      <MaterialCommunityIcons name={payment.icon as any} size={24} color={payment.color} />
                      <View style={styles.paymentInfo}>
                        <Text style={styles.paymentTitle}>{payment.title}</Text>
                        <Text style={styles.paymentDescription}>{payment.description}</Text>
                      </View>
                    </TouchableOpacity>
                  ))}
                </View>
                
                <View style={styles.orderSummary}>
                  <Text style={styles.sectionTitle}>Resumen del Pedido</Text>
                  
                  {cart.map(item => (
                    <View key={item.id} style={styles.summaryItem}>
                      <Image source={{ uri: item.image }} style={styles.summaryItemImage} />
                      <View style={styles.summaryItemInfo}>
                        <Text style={styles.summaryItemName}>{item.name}</Text>
                        <Text style={styles.summaryItemPrice}>
                          {CURRENCY_SYMBOLS[billingOptions.currency as keyof typeof CURRENCY_SYMBOLS]}{item.price.toFixed(2)}
                        </Text>
                      </View>
                    </View>
                  ))}
                  
                  <View style={styles.totals}>
                    <View style={styles.totalRow}>
                      <Text style={styles.totalLabel}>Subtotal</Text>
                      <Text style={styles.totalValue}>
                        {CURRENCY_SYMBOLS[billingOptions.currency as keyof typeof CURRENCY_SYMBOLS]}{getCartTotal().toFixed(2)}
                      </Text>
                    </View>
                    
                    <View style={styles.totalRow}>
                      <Text style={styles.totalLabel}>Impuestos (16%)</Text>
                      <Text style={styles.totalValue}>
                        {CURRENCY_SYMBOLS[billingOptions.currency as keyof typeof CURRENCY_SYMBOLS]}{(getCartTotal() * 0.16).toFixed(2)}
                      </Text>
                    </View>
                    
                    <View style={[styles.totalRow, styles.grandTotalRow]}>
                      <Text style={styles.grandTotalLabel}>Total</Text>
                      <Text style={styles.grandTotalValue}>
                        {CURRENCY_SYMBOLS[billingOptions.currency as keyof typeof CURRENCY_SYMBOLS]}{(getCartTotal() * 1.16).toFixed(2)}
                      </Text>
                    </View>
                  </View>
                </View>
              </View>
            )}            {checkoutStep === 3 && (
              <View>
                <Text style={styles.sectionTitle}>Confirmación del Pedido</Text>
                
                <View style={styles.confirmationSection}>
                  <Text style={styles.confirmationLabel}>Información de Contacto</Text>
                  <Text style={styles.confirmationValue}>{checkoutFormData.contactPerson || "No especificado"}</Text>
                  <Text style={styles.confirmationValue}>{checkoutFormData.email || "No especificado"}</Text>
                  <Text style={styles.confirmationValue}>{checkoutFormData.phone || "No especificado"}</Text>
                  <Text style={styles.confirmationValue}>{checkoutFormData.address || "No especificado"}</Text>
                </View>
                
                <View style={styles.confirmationSection}>
                  <Text style={styles.confirmationLabel}>Método de Pago</Text>
                  <Text style={styles.confirmationValue}>
                    {billingOptions.paymentMethod === 'cash' && 'Efectivo'}
                    {billingOptions.paymentMethod === 'transfer' && 'Transferencia Bancaria'}
                    {billingOptions.paymentMethod === 'card' && 'Tarjeta de Crédito/Débito'}
                  </Text>
                </View>
                
                <View style={styles.orderSummary}>
                  <Text style={styles.confirmationLabel}>Productos</Text>
                  
                  {cart.map(item => (
                    <View key={item.id} style={styles.summaryItem}>
                      <Image source={{ uri: item.image }} style={styles.summaryItemImage} />
                      <View style={styles.summaryItemInfo}>
                        <Text style={styles.summaryItemName}>{item.name}</Text>
                        <Text style={styles.summaryItemPrice}>
                          {CURRENCY_SYMBOLS[billingOptions.currency as keyof typeof CURRENCY_SYMBOLS]}{item.price.toFixed(2)}
                        </Text>
                      </View>
                    </View>
                  ))}
                  
                  <View style={styles.totals}>
                    <View style={styles.totalRow}>
                      <Text style={styles.totalLabel}>Subtotal</Text>
                      <Text style={styles.totalValue}>
                        {CURRENCY_SYMBOLS[billingOptions.currency as keyof typeof CURRENCY_SYMBOLS]}{getCartTotal().toFixed(2)}
                      </Text>
                    </View>
                    
                    <View style={styles.totalRow}>
                      <Text style={styles.totalLabel}>Impuestos (16%)</Text>
                      <Text style={styles.totalValue}>
                        {CURRENCY_SYMBOLS[billingOptions.currency as keyof typeof CURRENCY_SYMBOLS]}{(getCartTotal() * 0.16).toFixed(2)}
                      </Text>
                    </View>
                    
                    <View style={[styles.totalRow, styles.grandTotalRow]}>
                      <Text style={styles.grandTotalLabel}>Total</Text>
                      <Text style={styles.grandTotalValue}>
                        {CURRENCY_SYMBOLS[billingOptions.currency as keyof typeof CURRENCY_SYMBOLS]}{(getCartTotal() * 1.16).toFixed(2)}
                      </Text>
                    </View>
                  </View>
                </View>
              </View>
            )}
          </ScrollView>          <View style={styles.checkoutFooter}>
            {checkoutStep === 3 ? (
              <View style={styles.buttonRow}>
                <TouchableOpacity 
                  style={[styles.secondaryButton, {flex: 1, marginRight: 10}]}
                  onPress={goToPreviousStep}
                >
                  <Text style={styles.secondaryButtonText}>Regresar</Text>
                </TouchableOpacity>
                
                <TouchableOpacity 
                  style={[styles.primaryButton, {flex: 1, backgroundColor: "#4CAF50"}]}
                  onPress={completeOrder}
                >
                  <Text style={styles.primaryButtonText}>Completar Pedido</Text>
                </TouchableOpacity>
              </View>
            ) : (
              <View style={styles.buttonRow}>
                <TouchableOpacity 
                  style={[styles.secondaryButton, {flex: 1, marginRight: 10}]}
                  onPress={goToPreviousStep}
                >
                  <Text style={styles.secondaryButtonText}>Regresar</Text>
                </TouchableOpacity>
                
                <TouchableOpacity 
                  style={[styles.primaryButton, {flex: 1}]}
                  onPress={goToNextStep}
                >
                  <Text style={styles.primaryButtonText}>Continuar</Text>
                </TouchableOpacity>
              </View>
            )}
          </View>
        </KeyboardAvoidingView>
      </View>
    );
  };
  
  // SERVICE TAB
  const ServiceTab = () => {
    return (
      <ScrollView style={styles.screenContent}>
        <View style={styles.header}>
          <Text style={styles.headerTitle}>Servicios</Text>
          <TouchableOpacity 
            style={styles.cartButton}
            onPress={() => setShowCart(true)}
          >
            <MaterialCommunityIcons name="cart" size={24} color="#2196F3" />
            {cart.length > 0 && (
              <View style={styles.badge}>
                <Text style={styles.badgeText}>{cart.length}</Text>
              </View>
            )}
          </TouchableOpacity>
        </View>
        
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Servicios Predefinidos</Text>
          
          {SERVICES.map(service => (
            <TouchableOpacity 
              key={service.id}
              style={styles.serviceCard}
              onPress={() => addPredefinedService(service)}
            >
              <View style={styles.serviceIconContainer}>
                <MaterialCommunityIcons name={service.icon as any} size={24} color="#2196F3" />
              </View>
              <View style={styles.serviceInfo}>
                <Text style={styles.serviceName}>{service.name}</Text>
                <View style={styles.servicePriceRow}>
                  <Text style={styles.servicePrice}>
                    {service.discount ? (
                      <>
                        <Text style={styles.discountedPrice}>
                          ${service.price.toFixed(2)}
                        </Text>
                        {' $' + (service.price * (1 - service.discount / 100)).toFixed(2)}
                      </>
                    ) : (
                      '$' + service.price.toFixed(2)
                    )}
                  </Text>
                  {service.discount > 0 && (
                    <View style={styles.discountBadge}>
                      <Text style={styles.discountText}>{service.discount}% OFF</Text>
                    </View>
                  )}
                </View>
              </View>
            </TouchableOpacity>
          ))}
        </View>
        
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Servicio Personalizado</Text>
          
          <View style={styles.formField}>
            <Text style={styles.formLabel}>Descripción</Text>
            <TextInput
              style={styles.formInput}
              value={serviceForm.description}
              onChangeText={text => setServiceForm({...serviceForm, description: text})}
              placeholder="Describir servicio"
            />
          </View>
          
          <View style={styles.formRow}>
            <View style={[styles.formField, { flex: 1, marginRight: 10 }]}>
              <Text style={styles.formLabel}>Precio ($)</Text>
              <TextInput
                style={styles.formInput}
                value={serviceForm.price}
                onChangeText={text => {
                  setServiceForm({...serviceForm, price: text});
                  // Debounce calculation
                  setTimeout(() => calculateServicePrice(), 500);
                }}
                keyboardType="numeric"
                placeholder="0.00"
              />
            </View>
            
            <View style={[styles.formField, { flex: 1 }]}>
              <Text style={styles.formLabel}>Descuento (%)</Text>
              <TextInput
                style={styles.formInput}
                value={serviceForm.discount}
                onChangeText={text => {
                  setServiceForm({...serviceForm, discount: text});
                  // Debounce calculation
                  setTimeout(() => calculateServicePrice(), 500);
                }}
                keyboardType="numeric"
                placeholder="0"
              />
            </View>
          </View>
          
          {calculatedPrice > 0 && (
            <View style={styles.calculatedPriceContainer}>
              <Text style={styles.calculatedPriceLabel}>Precio Final:</Text>
              <Text style={styles.calculatedPriceValue}>
                ${calculatedPrice.toFixed(2)}
              </Text>
            </View>
          )}
          
          <TouchableOpacity 
            style={styles.primaryButton}
            onPress={addServiceToCart}
          >
            <Text style={styles.primaryButtonText}>Agregar al Carrito</Text>
          </TouchableOpacity>
        </View>
      </ScrollView>
    );
  };
  
  // Modal para Nuevo Cliente
const [showNewClientForm, setShowNewClientForm] = useState(false);
const [newClientForm, setNewClientForm] = useState({
  name: "",
  address: "",
  mobile: "",
  email: "",
  rut: "",
  observations: "",
  cedula: ""
});
const [newClientErrors, setNewClientErrors] = useState<Record<string, string>>({});

const resetNewClientForm = () => {
  setNewClientForm({
    name: "",
    address: "",
    mobile: "",
    email: "",
    rut: "",
    observations: "",
    cedula: ""
  });
  setNewClientErrors({});
};

const validateNewClientForm = () => {
  const errors: Record<string, string> = {};
  
  if (!newClientForm.name.trim()) {
    errors.name = "Nombre es requerido";
  }
  
  if (!newClientForm.email.trim()) {
    errors.email = "Email es requerido";
  } else if (!/\S+@\S+\.\S+/.test(newClientForm.email)) {
    errors.email = "Email inválido";
  }
  
  if (!newClientForm.mobile.trim()) {
    errors.mobile = "Móvil es requerido";
  }
  
  setNewClientErrors(errors);
  return Object.keys(errors).length === 0;
};

const handleSaveNewClient = () => {
  if (validateNewClientForm()) {
    // Aquí agregaríamos el nuevo cliente a la base de datos
    // Por ahora, solo simulamos añadirlo al array de clientes
    const newClient: Client = {
      id: `client-${Date.now()}`,
      name: newClientForm.name,
      email: newClientForm.email,
      totalPurchases: 0
    };
    
    // No modificamos el array original, pero podríamos hacer algo como:
    // CLIENTS.push(newClient);
    
    toast.success(`Cliente ${newClientForm.name} creado con éxito`);
    setShowNewClientForm(false);
    resetNewClientForm();
  }
};

// Form Field Component for New Client Form
const NewClientFormField: React.FC<{
  label: string;
  field: keyof typeof newClientForm;
  placeholder: string;
  keyboardType?: "default" | "email-address" | "numeric" | "phone-pad";
  multiline?: boolean;
}> = ({ label, field, placeholder, keyboardType = "default", multiline = false }) => {
  return (
    <View style={styles.formField}>
      <Text style={styles.formLabel}>
        {label} {field === "name" || field === "email" || field === "mobile" ? 
          <Text style={styles.requiredText}>*</Text> : null}
      </Text>
      <TextInput
        style={[
          styles.formInput, 
          newClientErrors[field] ? styles.inputError : {},
          multiline && styles.textArea
        ]}
        placeholder={placeholder}
        keyboardType={keyboardType}
        multiline={multiline}
        numberOfLines={multiline ? 4 : 1}
        value={newClientForm[field]}
        onChangeText={(text) => setNewClientForm(prev => ({ ...prev, [field]: text }))}
      />
      {newClientErrors[field] && (
        <Text style={styles.errorText}>{newClientErrors[field]}</Text>
      )}
    </View>
  );
};

// Modal for New Client
const NewClientModal = () => (
  <Modal
    visible={showNewClientForm}
    transparent={true}
    animationType="slide"
    onRequestClose={() => setShowNewClientForm(false)}
  >
    <View style={styles.modalOverlay}>
      <View style={[styles.modalContent, styles.newClientModal]}>
        <View style={styles.modalHeader}>
          <Text style={styles.modalTitle}>Registrar Nuevo Cliente</Text>
          <TouchableOpacity onPress={() => setShowNewClientForm(false)}>
            <MaterialCommunityIcons name="close" size={24} color="#666" />
          </TouchableOpacity>
        </View>
        
        <ScrollView style={styles.newClientForm}>
          <NewClientFormField 
            label="Nombre Completo" 
            field="name" 
            placeholder="Nombre y apellido" 
          />
          
          <NewClientFormField 
            label="Dirección" 
            field="address" 
            placeholder="Dirección completa" 
          />
          
          <NewClientFormField 
            label="Móvil" 
            field="mobile" 
            placeholder="Número de teléfono móvil" 
            keyboardType="phone-pad" 
          />
          
          <NewClientFormField 
            label="Email" 
            field="email" 
            placeholder="correo@ejemplo.com" 
            keyboardType="email-address" 
          />
          
          <NewClientFormField 
            label="RUT" 
            field="rut" 
            placeholder="Número de identificación fiscal" 
          />
          
          <NewClientFormField 
            label="Cédula" 
            field="cedula" 
            placeholder="Número de identificación personal" 
          />
          
          <NewClientFormField 
            label="Observaciones" 
            field="observations" 
            placeholder="Notas adicionales sobre el cliente..." 
            multiline={true} 
          />
        </ScrollView>
        
        <View style={styles.modalFooter}>
          <TouchableOpacity 
            style={styles.secondaryButton}
            onPress={() => setShowNewClientForm(false)}
          >
            <Text style={styles.secondaryButtonText}>Cancelar</Text>
          </TouchableOpacity>
          
          <TouchableOpacity 
            style={styles.primaryButton}
            onPress={handleSaveNewClient}
          >
            <Text style={styles.primaryButtonText}>Guardar Cliente</Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  </Modal>
);

// CLIENTS TAB

const ClientsTab = () => {
  const [busqueda, setBusqueda] = useState("");
  const [clientes, setClientes] = useState<Client[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedClient, setSelectedClient] = useState<Client | null>(null);
  //const { cart, setShowNewClientForm, setShowCart } = useContext(AppContext);

  
/*  const buscarClientes = async () => {

    console.log("ando por aca")
    console.log("busqueda ")
    const resultados = await fetchClientesDesdeAPI(busqueda);
    setClientes(resultados);
  };*/

  const buscarClientes = async () => {
    try {
     setIsLoading(true);
      const resultados = await fetchClientesDesdeAPI(busqueda);
      console.log("Resultado de búsqueda:", resultados);
      setClientes(resultados);
    } catch (error) {
      toast.error("Error al buscar clientes");
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const cargarClientes = async () => {
      setIsLoading(true);
      const clientes = await fetchClientesDesdeAPI('CONSUMIDOR');
      setClientes(clientes);
      setIsLoading(false);
    };
    cargarClientes();
  }, []);

  return (
    <ScrollView style={styles.screenContent}>
      <View style={styles.header}>
        <Text style={styles.headerTitle}>Clientes</Text>
        <View style={styles.headerActions}>
          <TouchableOpacity style={styles.headerButton} onPress={() => setShowNewClientForm(true)}>
            <MaterialCommunityIcons name="account-plus" size={24} color="#4CAF50" />
          </TouchableOpacity>
          <TouchableOpacity style={styles.cartButton} onPress={() => setShowCart(true)}>
            <MaterialCommunityIcons name="cart" size={24} color="#2196F3" />
            {cart.length > 0 && (
              <View style={styles.badge}>
                <Text style={styles.badgeText}>{cart.length}</Text>
              </View>
            )}
          </TouchableOpacity>
        </View>
      </View>

      <Text style={styles.sectionTitle}>Buscar Cliente</Text>
      <View style={styles.searchContainer}>
        <TextInput
          style={styles.searchInput}
          placeholder="Buscar por nombre o email"
          value={busqueda}
          onChangeText={setBusqueda}
        />
        <TouchableOpacity
          style={[styles.searchButton, isLoading && { backgroundColor: '#ccc' }]}
          onPress={buscarClientes}
          disabled={isLoading}
        >
          {isLoading ? (
            <ActivityIndicator color="#fff" size="small" />
          ) : (
            <MaterialCommunityIcons name="magnify" size={24} color="#fff" />
          )}
        </TouchableOpacity>
      </View>

      <Text style={styles.sectionTitle}>Seleccionar Cliente</Text>
      {isLoading ? (
        <View style={{ alignItems: 'center', marginVertical: 10 }}>
          <Text style={{ textAlign: 'center', marginBottom: 5 }}>Buscando clientes...</Text>
          <ActivityIndicator size="small" color="#4CAF50" />
        </View>
      ) : clientes.length === 0 ? (
        <Text style={{ textAlign: 'center', marginVertical: 10, color: '#999' }}>
          No se encontraron clientes para la búsqueda actual.
        </Text>
      ) : (
        clientes.map(client => (
          <TouchableOpacity
            key={client.id}
            style={[styles.clientCard, selectedClient?.id === client.id && styles.selectedClientCard]}
            onPress={() => selectClient(client)}
          >
            <View style={styles.clientAvatar}>
              <MaterialCommunityIcons name="account" size={30} color="#fff" />
            </View>
            <View style={styles.clientInfo}>
            <Text style={{ fontWeight: 'bold', fontSize: 16 }}>
      🆔 {client.id}
    </Text>
    <Text style={{ fontSize: 15 }}>
      👤 {client.name}
    </Text>
    {client.email !== '' && (
      <Text style={{ fontSize: 14 }}>
        📧 {client.email}
      </Text>
    )}
               <Text style={{ fontSize: 14 }}>
      💰 Saldo: {client.totalPurchases.toFixed(2)}
    </Text>
            </View>
            {selectedClient?.id === client.id && (
              <MaterialCommunityIcons name="check-circle" size={24} color="#4CAF50" />
            )}
          </TouchableOpacity>
        ))
      )}

      <NewClientModal />
    </ScrollView>
  );
};
  // STORE TAB
  const StoreTab = () => {
    return (
      <ScrollView style={styles.screenContent}>
        <View style={styles.header}>
          <Text style={styles.headerTitle}>Tienda</Text>
          <TouchableOpacity 
            style={styles.cartButton}
            onPress={() => setShowCart(true)}
          >
            <MaterialCommunityIcons name="cart" size={24} color="#2196F3" />
            {cart.length > 0 && (
              <View style={styles.badge}>
                <Text style={styles.badgeText}>{cart.length}</Text>
              </View>
            )}
          </TouchableOpacity>
        </View>
        
        {selectedClient && (
          <View style={styles.clientBanner}>
            <Text style={styles.clientBannerText}>
              Cliente: {selectedClient.name}
            </Text>
            <TouchableOpacity onPress={() => setSelectedClient(null)}>
              <Text style={styles.clientBannerAction}>Cambiar</Text>
            </TouchableOpacity>
          </View>
        )}
        
        {!selectedCategory ? (
          <>
            <Text style={styles.sectionTitle}>Categorías</Text>
            
            {CATEGORIES.map(category => (
              <TouchableOpacity 
                key={category.id} 
                style={styles.categoryCard}
                onPress={() => {
                  setIsLoading(true); // Mostrar loading inmediato
                  setSelectedCategory(category);
                }}
              >
                <Image source={{ uri: category.image }} style={styles.categoryImage} />
                <View style={styles.categoryInfo}>
                  <Text style={styles.categoryName}>{category.name}</Text>
                  <Text style={styles.categoryDescription}>{category.description}</Text>
                  <View style={styles.categoryBadge}>
                    <Text style={styles.categoryBadgeText}>{category.productCount} productos</Text>
                  </View>
                </View>
              </TouchableOpacity>
            ))}
          </>
        ) : (
          <>
            <View style={styles.categoryHeader}>
              <TouchableOpacity 
                style={styles.backButton}
                onPress={() => setSelectedCategory(null)}
              >
                <MaterialCommunityIcons name="arrow-left" size={20} color="#2196F3" />
                <Text style={styles.backButtonText}>Categorías</Text>
              </TouchableOpacity>
              <Text style={styles.sectionTitle}>{selectedCategory.name}</Text>
            </View>
            
            {isLoading ? (
            <View style={styles.loadingContainer}>
              <ActivityIndicator size="large" color="#4CAF50" />
              <Text style={styles.loadingText}>Cargando productos...</Text>
            </View>
          ) : (
            PRODUCTS.filter(p => p.category === selectedCategory.name).map(product => (
              <ProductCard key={product.id} product={product} onAddToCart={addToCart} />
            ))
          )}
          </>
        )}
        
        <Text style={[styles.sectionTitle, { marginTop: 20 }]}>Productos Destacados</Text>
        
        {PRODUCTS.slice(0, 2).map(product => (
          <ProductCard key={product.id} product={product} onAddToCart={addToCart} />
        ))}
      </ScrollView>
    );
  };
  
  // MAIN RENDER
  return (
    <SafeAreaView style={styles.container}>
      {/* Main Content */}
      {tab === 'home' && ( 

<ScrollView
contentContainerStyle={[styles.screenContent, { paddingBottom: 120 }]}
showsVerticalScrollIndicator={false}
>
<View style={styles.header}>
  <Text style={styles.headerTitle}>Sistema de Punto de Venta</Text>
  <TouchableOpacity
    style={styles.cartButton}
    onPress={() => setShowCart(true)}
  >
    <MaterialCommunityIcons name="cart" size={24} color="#2196F3" />
    {cart.length > 0 && (
      <View style={styles.badge}>
        <Text style={styles.badgeText}>{cart.length}</Text>
      </View>
    )}
  </TouchableOpacity>
</View>

<Text style={styles.welcomeText}>Bienvenido a su sistema de gestión</Text>

<View style={styles.quickActions}>
  <TouchableOpacity
    style={styles.actionButton}
    onPress={() => setTab('store')}
  >
    <MaterialCommunityIcons name="store" size={28} color="#2196F3" />
    <Text style={styles.actionButtonText}>Tienda</Text>
  </TouchableOpacity>

  <TouchableOpacity
    style={styles.actionButton}
    onPress={() => setTab('services')}
  >
    <MaterialCommunityIcons name="tools" size={28} color="#FF9800" />
    <Text style={styles.actionButtonText}>Servicios</Text>
  </TouchableOpacity>

  <TouchableOpacity
    style={styles.actionButton}
    onPress={() => setTab('clients')}
  >
    <MaterialCommunityIcons name="account-group" size={28} color="#4CAF50" />
    <Text style={styles.actionButtonText}>Clientes</Text>
  </TouchableOpacity>
</View>

{selectedClient && (
  <View style={styles.clientBanner}>
    <Text style={styles.clientBannerText}>
      Cliente activo: {selectedClient.name}
    </Text>
    <TouchableOpacity onPress={() => setSelectedClient(null)}>
      <Text style={styles.clientBannerAction}>Cambiar</Text>
    </TouchableOpacity>
  </View>
)}

<Text style={styles.sectionTitle}>Productos Destacados</Text>

{

  // Este es el bloque que mostrará productos o el spinner
 (
  <ScrollView style={styles.container}>
    {isLoading ? (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color="#4CAF50" />
        <Text style={styles.loadingText}>Cargando productos...</Text>
      </View>
    ) : (
      PRODUCTS.map(producto => (
        <View key={producto.id} style={styles.productCard}>
          <Image source={{ uri: producto.image }} style={styles.productImage} />
          <Text style={styles.productName}>{producto.name}</Text>
          <Text style={styles.productPrice}>${producto.price.toFixed(2)}</Text>
          {producto.destacado && <Text style={styles.destacado}>Destacado ⭐</Text>}
        </View>
      ))
    )}
  </ScrollView>
)

}
</ScrollView>
      )}
      
      {tab === 'store' && <StoreTab />}
      {tab === 'services' && <ServiceTab />}
      {tab === 'clients' && <ClientsTab  />}
      
      {/* Bottom Navigation */}
      <View style={styles.bottomNav}>
        <TouchableOpacity 
          style={[styles.navItem, tab === 'home' && styles.activeNavItem]}
          onPress={() => setTab('home')}
        >
          <MaterialCommunityIcons 
            name="home" 
            size={24} 
            color={tab === 'home' ? '#2196F3' : '#757575'} 
          />
          <Text style={[styles.navLabel, tab === 'home' && styles.activeNavLabel]}>
            Inicio
          </Text>
        </TouchableOpacity>
        
        <TouchableOpacity 
          style={[styles.navItem, tab === 'store' && styles.activeNavItem]}
          onPress={() => setTab('store')}
        >
          <MaterialCommunityIcons 
            name="store" 
            size={24} 
            color={tab === 'store' ? '#2196F3' : '#757575'} 
          />
          <Text style={[styles.navLabel, tab === 'store' && styles.activeNavLabel]}>
            Tienda
          </Text>
        </TouchableOpacity>
        
        <TouchableOpacity 
          style={[styles.navItem, tab === 'services' && styles.activeNavItem]}
          onPress={() => setTab('services')}
        >
          <MaterialCommunityIcons 
            name="tools" 
            size={24} 
            color={tab === 'services' ? '#2196F3' : '#757575'} 
          />
          <Text style={[styles.navLabel, tab === 'services' && styles.activeNavLabel]}>
            Servicios
          </Text>
        </TouchableOpacity>
        
        <TouchableOpacity 
          style={[styles.navItem, tab === 'clients' && styles.activeNavItem]}
          onPress={() => setTab('clients')}
        >
          <MaterialCommunityIcons 
            name="account-group" 
            size={24} 
            color={tab === 'clients' ? '#2196F3' : '#757575'} 
          />
          <Text style={[styles.navLabel, tab === 'clients' && styles.activeNavLabel]}>
            Clientes
          </Text>
        </TouchableOpacity>
      </View>
      
      {/* Modals */}
      <CartModal />
      <CheckoutScreen />
    </SafeAreaView>
  );

  
};

const styles = StyleSheet.create({
  searchContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 10,
    paddingHorizontal: 10
  },
  searchInput: {
    flex: 1,
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 8,
    paddingHorizontal: 10,
    height: 40,
    marginRight: 10,
    backgroundColor: '#fff'
  },
  searchButton: {
    backgroundColor: '#4CAF50',
    padding: 10,
    borderRadius: 8
  },
  container: {
    flex: 1,
    backgroundColor: "#f5f5f5",
  },
  headerActions: {
    flexDirection: "row",
    alignItems: "center",
  },
  headerButton: {
    marginRight: 12,
    padding: 4,
  },
  newClientModal: {
    maxHeight: "80%",
    width: "90%",
  },
  newClientForm: {
    flex: 1,
  },
  modalFooter: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 16,
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: "#eee",
  },
  textArea: {
    height: 100,
    textAlignVertical: "top",
    paddingTop: 10,
  },
  screenContent: {
    padding: 16,
    paddingBottom: 160, // Espacio suficiente para ver el botón
  },
  
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  headerTitle: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#333',
  },
  welcomeText: {
    fontSize: 16,
    color: '#666',
    marginBottom: 20,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 12,
    marginTop: 12,
  },
  
  /* Product Card Styles */
  productCard: {
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 16,
    marginBottom: 16,
    flexDirection: 'row',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  productImage: {
    width: 80,
    height: 80,
    borderRadius: 8,
    marginRight: 16,
  },
  productInfo: {
    flex: 1,
  },
  productName: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 4,
  },
  productDescription: {
    fontSize: 14,
    color: '#666',
    marginBottom: 8,
  },
  productPriceRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
  },
  productPrice: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#2196F3',
  },
  discountedPrice: {
    fontSize: 14,
    textDecorationLine: 'line-through',
    color: '#999',
    marginRight: 4,
  },
  discountBadge: {
    backgroundColor: '#FF5252',
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 4,
    marginLeft: 8,
  },
  discountText: {
    color: '#fff',
    fontSize: 12,
    fontWeight: 'bold',
  },
  addButton: {
    backgroundColor: '#2196F3',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 4,
    alignSelf: 'flex-end',
  },
  addButtonText: {
    color: '#fff',
    fontSize: 14,
    fontWeight: 'bold',
    marginLeft: 4,
  },
  
  /* Cart Styles */
  cartButton: {
    position: 'relative',
    padding: 6,
  },
  badge: {
    position: 'absolute',
    right: 0,
    top: 0,
    backgroundColor: '#FF5252',
    width: 18,
    height: 18,
    borderRadius: 9,
    justifyContent: 'center',
    alignItems: 'center',
  },
  badgeText: {
    color: '#fff',
    fontSize: 10,
    fontWeight: 'bold',
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
  },
  modalContent: {
    backgroundColor: '#fff',
    borderRadius: 12,
    width: '90%',
    maxHeight: '80%',
    padding: 16,
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
  },
  emptyMessage: {
    textAlign: 'center',
    fontSize: 16,
    color: '#666',
    marginVertical: 20,
  },
  cartList: {
    marginBottom: 16,
  },
  cartItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
  },
  cartItemImage: {
    width: 50,
    height: 50,
    borderRadius: 8,
    marginRight: 12,
  },
  cartItemInfo: {
    flex: 1,
  },
  cartItemName: {
    fontSize: 15,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 4,
  },
  cartItemPrice: {
    fontSize: 14,
    color: '#2196F3',
    fontWeight: 'bold',
  },
  cartTotal: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginVertical: 16,
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: '#eee',
  },
  cartTotalLabel: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
  },
  cartTotalAmount: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#2196F3',
  },
  
  /* Form Styles */
  formField: {
    marginBottom: 16,
  },
  formLabel: {
    fontSize: 14,
    color: '#666',
    marginBottom: 6,
  },
  formInput: {
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: '#ddd',
    borderRadius: 6,
    padding: 10,
    fontSize: 15,
  },
  inputError: {
    borderColor: '#FF5252',
  },
  errorText: {
    color: '#FF5252',
    fontSize: 12,
    marginTop: 4,
  },
  requiredText: {
    color: '#FF5252',
  },
  formRow: {
    flexDirection: 'row',
    marginBottom: 16,
  },
  calculatedPriceContainer: {
    backgroundColor: '#EDF7FF',
    borderRadius: 6,
    padding: 12,
    marginBottom: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  calculatedPriceLabel: {
    fontSize: 14,
    color: '#2196F3',
  },
  calculatedPriceValue: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#2196F3',
  },
  
  /* Navigation Styles */
  bottomNav: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    flexDirection: 'row',
    height: 60,
    borderTopWidth: 1,
    borderTopColor: '#eee',
    paddingBottom: Platform.OS === 'ios' ? 20 : 0,
  },
  navItem: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  activeNavItem: {
    borderTopWidth: 2,
    borderTopColor: '#2196F3',
  },
  navLabel: {
    fontSize: 12,
    color: '#757575',
    marginTop: 4,
  },
  activeNavLabel: {
    color: '#2196F3',
    fontWeight: 'bold',
  },
  
  /* Service Styles */
  serviceCard: {
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 16,
    marginBottom: 12,
    flexDirection: 'row',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 1,
  },
  serviceIconContainer: {
    width: 50,
    height: 50,
    borderRadius: 25,
    backgroundColor: '#E3F2FD',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  serviceInfo: {
    flex: 1,
  },
  serviceName: {
    fontSize: 15,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 4,
  },
  servicePriceRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  servicePrice: {
    fontSize: 15,
    fontWeight: 'bold',
    color: '#2196F3',
  },
  
  /* Category Styles */
  categoryCard: {
    backgroundColor: '#fff',
    borderRadius: 8,
    overflow: 'hidden',
    marginBottom: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  categoryImage: {
    width: '100%',
    height: 120,
  },
  categoryInfo: {
    padding: 16,
  },
  categoryName: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 4,
  },
  categoryDescription: {
    fontSize: 14,
    color: '#666',
    marginBottom: 8,
  },
  categoryBadge: {
    backgroundColor: '#E3F2FD',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 4,
    alignSelf: 'flex-start',
  },
  categoryBadgeText: {
    color: '#2196F3',
    fontSize: 12,
    fontWeight: 'bold',
  },
  categoryHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
  },
  backButton: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 16,
  },
  backButtonText: {
    color: '#2196F3',
    fontSize: 14,
    marginLeft: 4,
  },
  
  /* Client Styles */
  clientCard: {
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 16,
    marginBottom: 12,
    flexDirection: 'row',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 1,
  },
  selectedClientCard: {
    borderColor: '#2196F3',
    borderWidth: 1,
    backgroundColor: '#E3F2FD',
  },
  clientAvatar: {
    width: 50,
    height: 50,
    borderRadius: 25,
    backgroundColor: '#2196F3',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  clientInfo: {
    flex: 1,
  },
  clientName: {
    fontSize: 15,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 2,
  },
  clientEmail: {
    fontSize: 14,
    color: '#666',
    marginBottom: 2,
  },
  clientPurchases: {
    fontSize: 13,
    color: '#666',
  },
  clientBanner: {
    backgroundColor: '#E3F2FD',
    borderRadius: 8,
    padding: 12,
    marginBottom: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  clientBannerText: {
    fontSize: 14,
    color: '#2196F3',
    fontWeight: 'bold',
  },
  clientBannerAction: {
    color: '#2196F3',
    fontWeight: 'bold',
  },
  
  /* Button Styles */
  primaryButton: {
    backgroundColor: '#2196F3',
    borderRadius: 6,
    paddingVertical: 12,
    alignItems: 'center',
    justifyContent: 'center',
  },
  primaryButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },
  secondaryButton: {
    backgroundColor: '#E3F2FD',
    borderRadius: 6,
    paddingVertical: 12,
    paddingHorizontal: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  secondaryButtonText: {
    color: '#2196F3',
    fontSize: 16,
    fontWeight: 'bold',
  },
  buttonRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  quickActions: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  actionButton: {
    flex: 1,
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 16,
    marginHorizontal: 4,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 1,
  },
  actionButtonText: {
    fontSize: 14,
    color: '#333',
    marginTop: 8,
  },
  
  /* Checkout Styles */
  fullscreenOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#fff',
    zIndex: 1000,
  },
  fullscreenContainer: {
    flex: 1,
  },
  checkoutHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
  },
  checkoutTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
  },
  cancelText: {
    color: '#FF5252',
    fontSize: 16,
  },
  checkoutContent: {
    flex: 1,
    padding: 16,
  },
  checkoutFooter: {
    padding: 16,
    borderTopWidth: 1,
    borderTopColor: '#eee',
  },
  progressIndicator: {
    padding: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    position: 'relative',
  },
  progressBar: {
    position: 'absolute',
    left: 50,
    right: 50,
    top: 35,
    height: 2,
    backgroundColor: '#eee',
    zIndex: -1,
  },
  progressFill: {
    height: '100%',
    backgroundColor: '#2196F3',
    width: '0%',
  },
  stepItem: {
    alignItems: 'center',
  },
  stepCircle: {
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: '#eee',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 4,
  },
  activeStep: {
    backgroundColor: '#2196F3',
  },
  stepNumber: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#666',
  },
  activeStepNumber: {
    color: '#fff',
  },
  stepLabel: {
    fontSize: 12,
    color: '#666',
  },
  activeStepLabel: {
    color: '#2196F3',
    fontWeight: 'bold',
  },
  
  /* Payment and Currency Styles */
  currencySelector: {
    marginBottom: 16,
  },
  optionRow: {
    flexDirection: 'row',
    marginTop: 6,
  },
  currencyOption: {
    borderWidth: 1,
    borderColor: '#ddd',
    borderRadius: 4,
    paddingVertical: 8,
    paddingHorizontal: 12,
    marginRight: 8,
  },
  selectedOption: {
    borderColor: '#2196F3',
    backgroundColor: '#E3F2FD',
  },
  optionText: {
    color: '#666',
  },
  selectedOptionText: {
    color: '#2196F3',
    fontWeight: 'bold',
  },
  paymentMethods: {
    marginBottom: 16,
  },
  paymentMethod: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 16,
    marginBottom: 8,
    borderWidth: 1,
    borderColor: '#eee',
  },
  selectedPayment: {
    borderColor: '#2196F3',
    backgroundColor: '#E3F2FD',
  },
  paymentInfo: {
    marginLeft: 12,
    flex: 1,
  },
  paymentTitle: {
    fontSize: 15,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 2,
  },
  paymentDescription: {
    fontSize: 13,
    color: '#666',
  },
  
  /* Order Summary Styles */
  orderSummary: {
    marginTop: 16,
  },
  summaryItem: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 12,
    marginBottom: 8,
  },
  summaryItemImage: {
    width: 40,
    height: 40,
    borderRadius: 4,
    marginRight: 12,
  },
  summaryItemInfo: {
    flex: 1,
  },
  summaryItemName: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 2,
  },
  summaryItemPrice: {
    fontSize: 13,
    color: '#2196F3',
    fontWeight: 'bold',
  },
  totals: {
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 16,
    marginTop: 12,
  },
  totalRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  totalLabel: {
    fontSize: 14,
    color: '#666',
  },
  totalValue: {
    fontSize: 14,
    color: '#333',
    fontWeight: 'bold',
  },
  grandTotalRow: {
    marginTop: 8,
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: '#eee',
  },
  grandTotalLabel: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
  },
  grandTotalValue: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#2196F3',
  },
  
  /* Confirmation Styles */
  confirmationSection: {
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 16,
    marginBottom: 16,
  },
  confirmationLabel: {
    fontSize: 14,
    color: '#666',
    marginBottom: 8,
  },
  confirmationValue: {
    fontSize: 15,
    color: '#333',
    marginBottom: 4,
  },
  section: {
    marginBottom: 24,
  }, 
  loadingContainer: {
    marginTop: 40,
    alignItems: 'center'
  },
  loadingText: {
    marginTop: 10,
    fontSize: 16,
    color: '#555'
  }, destacado: {
    marginTop: 6,
    color: '#e91e63',
    fontWeight: '600'
  }
});


 

export default HomeScreen;